import { render } from "./KappEventsList.vue?vue&type=template&id=1410e11a"
import script from "./KappEventsList.vue?vue&type=script&lang=js"
export * from "./KappEventsList.vue?vue&type=script&lang=js"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__